import React, { useContext } from "react";
import PageList from "./pageList";
import AddUpdate from "./addUpdate";
import { CompaniesContext } from "../../contexts";


function Main(props) {
  const { state } = useContext(CompaniesContext);

  return state.page === "pageList" ?
    <PageList {...props} />
    :
    <AddUpdate {...props} />

}

export default Main;

